import { puzzlesJson } from "../json/puzzles.json";
import { lib } from "./lib.js";
import { storage } from "./storage.js";

var archive = function() 
{    
    const $archiveGameDetails = document.getElementById("archive-game-details");
    const $archiveGameTitle = document.getElementById("archive-game-title");
    const $archiveGameDate = document.getElementById("archive-game-date");
    const $archiveGameStats = document.getElementById("archive-game-stats");
    const $btnArchivePlay = document.getElementById("btn-archive-play");
    const $btnArchiveContinue = document.getElementById("btn-archive-continue");
    const $btnArchiveRestart = document.getElementById("btn-archive-restart");
    const $btnArchiveReplay = document.getElementById("btn-archive-replay");
    const $btnArchiveShare = document.getElementById("btn-archive-share");

    const $btnRestart = document.getElementById("btn-restart");
    const $btnCloseRestart = document.getElementById("btn-close-restart");
    
    const monthYearElement = document.getElementById("monthYear");
    const datesElement = document.getElementById("dates");    
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    const restartElements = document.querySelectorAll(".restart");
    const replayElements = document.querySelectorAll(".replay");

    var selectedDate = null;
    var selectedPuzzleNumber = 0;

    let completedGames = [];
    let userGames = [];
    let currentDate = new Date();

    const updateCompletedGames = (cg) => 
    {
        completedGames = cg;
    }

    const updateUserGames = (ug) =>
    {
        userGames = ug;
    }

    const getArchiveDayClass = (dateString) => 
    {
        var cssClass = "";
        
        for (const cg of completedGames) 
        {
            if (cg.gameDate === dateString)
            {
                cssClass = lib.getPercentageScoreClass(cg.percentage);
            }
        }

        return cssClass;
    }

    const updateCalendar = () => 
    {
        const currentyear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();    

        const launchDate = new Date(2025, 1, 17);
        const today = new Date();
        
        const firstDay = new Date(currentyear, currentMonth, 0); 
        const lastDay = new Date(currentyear, currentMonth + 1, 0);
        const totalDays = lastDay.getDate();
        const firstDayIndex = firstDay.getDay();
        const lastDayIndex = lastDay.getDay();

        const monthYearString = currentDate.toLocaleString('default', { month: 'long', year: 'numeric' });
        monthYearElement.textContent = monthYearString;

        let datesHTML = '';

        for (let i = firstDayIndex; i > 0; i--) 
        {
            const prevDate = new Date(currentyear, currentMonth, 0 - i + 1);
            datesHTML += `<div class="date inactive">${prevDate.getDate()}</div>`;
        }

        for (let i = 1; i <= totalDays; i++) 
        {
            const date = new Date(currentyear, currentMonth, i);
            const dateString = currentyear + "-" + String(currentMonth + 1).padStart(2, '0') + "-" + String(i).padStart(2, '0');
            let activeClass = (date >= launchDate && date <= today) ? '' : ' inactive';
            let percentageClass = getArchiveDayClass(dateString);
            datesHTML += `<div data-date="${dateString}" class="date${activeClass}${(percentageClass == "") ? "" : " " + percentageClass}">${i}</div>`;
        }

        for (let i = 1; i <= 7 - lastDayIndex; i++) 
        {
            const nextDate = new Date(currentyear, currentMonth + 1, i);
            datesHTML += `<div class="date inactive">${nextDate.getDate()}</div>`;
        }

        datesElement.innerHTML = datesHTML;
    }   

    // refresh when user comes back to archive
    function refreshCalendar()
    {
        if (selectedDate != null)
        {
            selectDate(selectedDate);
        }
    }

    function formatArchiveStatus(percentage, score, maxScore, hints)
    {
        var markup = `<div id="archive-status-percentage">
                        <div id="archive-percentage-container" class="` + lib.getPercentageScoreClass(percentage) + ` percentage-container">
                            <div class="vertical-center">
                                <span id="percentage-score">` + percentage + `</span>%
                            </div>
                        </div>
                    </div>
                    <div id="archive-status-details">
                        <div>` + score + "/" + maxScore  + `</div>
                        <div id="archive-status-hints">Hints Used: ` + (hints === undefined ? "?" : hints) + `</div>
                    </div>                    
                    `;

        return markup;
    }

    function unselectDate()
    {
        selectedDate = null;
        selectedPuzzleNumber = 0;
        $archiveGameDetails.classList.add("hide");
    }

    function selectDate(dateString)
    {
        var dateList = document.querySelectorAll(".date");
        [].forEach.call(dateList, function (x) { x.classList.remove("selected"); });
        const dateElement = document.querySelectorAll('[data-date="' + dateString + '"]');
        dateElement[0].classList.add("selected");
            
        selectedDate = dateString;

        var archiveDate = new Date(dateString);
        var puzzle = null;

        // load puzzle
        [].forEach.call(puzzlesJson, function(g) 
        {      
            if (g["d"] === dateString) 
            {
                puzzle = g;
            }
        }); 

        if (puzzle != null)
        {
            selectedPuzzleNumber = puzzle["n"];

            $archiveGameTitle.textContent = "Puzzle #" + puzzle["n"];
            $archiveGameDate.textContent = archiveDate.toLocaleString('default', { month: 'long' })
                + " " + archiveDate.toLocaleString('default', { day: 'numeric' }) + ", " 
                + archiveDate.toLocaleString('default', { year: 'numeric' });

            var selectedGameCompleted = null;

            for (const cg of completedGames) 
            {
                if (cg.gameNumber === selectedPuzzleNumber)
                {
                    selectedGameCompleted = cg;
                }
            }

            var selectedGameInProgress = null;

            userGames.forEach((g, index) =>
            {
                if (g["gameNumber"] == selectedPuzzleNumber)
                {
                    selectedGameInProgress = g;
                }
            });

            if (selectedGameCompleted != null)
            {
                var percentage = Math.floor(100 / parseInt(puzzle["p"]) * selectedGameCompleted["score"]);               

                // TODO: need to work out max score.  Also not sure we need to store percentage in completed games as we can calculate it here?
                $archiveGameStats.innerHTML = formatArchiveStatus(percentage,
                    selectedGameCompleted["score"], 
                    puzzle["p"], 
                    selectedGameInProgress == null ? "?" : selectedGameInProgress["hints"].length);
                    
                $btnArchivePlay.classList.add("hide");
                $btnArchiveContinue.classList.add("hide");
                $btnArchiveRestart.classList.add("hide");
                $btnArchiveReplay.classList.remove("hide");
                $btnArchiveShare.classList.remove("hide");
            }
            else if (selectedGameInProgress != null)
            {
                var foundWords = selectedGameInProgress.foundWords;
                var foundwordsPoints = [];
                var foundWordsScore = 0;
                
                for (var i = 0; i < (foundWords.length >= 5 ? 5 : foundWords.length); i++) 
                {
                    foundwordsPoints.push(parseInt(foundWords[i]["points"]));
                }
                
                foundWordsScore = foundwordsPoints.reduce((partialSum, a) => partialSum + a, 0);

                var percentage = Math.floor(100 / parseInt(puzzle["p"]) * foundWordsScore);
                console.log("Percentage: " + percentage);
                $archiveGameStats.innerHTML = formatArchiveStatus(percentage,
                    foundWordsScore, 
                    puzzle["p"], 
                    selectedGameInProgress["hints"].length);
                                
                $btnArchivePlay.classList.add("hide");
                $btnArchiveContinue.classList.remove("hide");
                $btnArchiveRestart.classList.remove("hide");
                $btnArchiveReplay.classList.add("hide");
                $btnArchiveShare.classList.add("hide");
            }   
            else {
                $archiveGameStats.innerHTML = "";

                $btnArchivePlay.classList.remove("hide");
                $btnArchiveContinue.classList.add("hide");
                $btnArchiveRestart.classList.add("hide");
                $btnArchiveReplay.classList.add("hide");
                $btnArchiveShare.classList.add("hide");
            }   

            $archiveGameDetails.classList.remove("hide");
        }
        else {
            selectedPuzzleNumber = 0;
            $archiveGameDetails.classList.add("hide");
        }
    }

    function bindEvents() 
    {
        document.addEventListener("click", function(e){
            const target = e.target.closest(".date"); // Or any other selector.

            if (target && !target.classList.contains("inactive")){
                const dateString = target.getAttribute("data-date");
                selectDate(dateString);                
            }
        });

        prevBtn.addEventListener("click", (e) => 
        {
            e.preventDefault();    
            currentDate.setMonth(currentDate.getMonth() - 1);
            unselectDate();
            updateCalendar();
            nextBtn.disabled = false;

            if (currentDate.getMonth() === 1 
                && currentDate.getFullYear() === 2025) 
            {
                prevBtn.disabled = true;
            }
        });

        nextBtn.addEventListener("click", (e) => 
        {
            e.preventDefault();
            currentDate.setMonth(currentDate.getMonth() + 1);
            unselectDate();
            updateCalendar();
            prevBtn.disabled = false;

            if (currentDate.getMonth() === new Date().getMonth() 
                && currentDate.getFullYear() === new Date().getFullYear()) 
            {
                nextBtn.disabled = true;
            }
        });

        $btnArchivePlay.addEventListener("click", (e) => 
        {
            e.preventDefault();

            playGame(selectedPuzzleNumber);
        });

        $btnArchiveContinue.addEventListener("click", (e) => 
        {
            e.preventDefault();

            playGame(selectedPuzzleNumber);     
        });

        $btnCloseRestart.addEventListener("click", (e) => 
        {
            e.preventDefault(); 

            lib.closeDialog(e.target);
        });

        $btnRestart.addEventListener("click", (e) => 
        {
            e.preventDefault(); 
            
            restartGame();

            lib.closeDialog(e.target);
        });

        $btnArchiveRestart.addEventListener("click", (e) => 
        {
            e.preventDefault();
            
            restartElements.forEach((el) => 
            {
                el.classList.remove("hide");
            });

            replayElements.forEach((el) => 
            {
                el.classList.add("hide");
            });
            
            lib.openDialog("dialog-restart");
        });

        $btnArchiveReplay.addEventListener("click", (e) => 
        {
            e.preventDefault();
         
            restartElements.forEach((el) => 
            {
                el.classList.add("hide");
            });

            replayElements.forEach((el) => 
            {
                el.classList.remove("hide");
            });

            lib.openDialog("dialog-restart");
        });        

        $btnArchiveShare.addEventListener("click", (e) => 
        {
            e.preventDefault();
            
            var selectedGameCompleted = null;

            for (const cg of completedGames) 
            {
                if (cg.gameNumber === selectedPuzzleNumber)
                {
                    selectedGameCompleted = cg;
                }
            }

            var userGame = null;

            for (const ug of userGames)
            {
                if (ug.gameNumber === selectedPuzzleNumber)
                {
                    userGame = ug;
                }
            }

            var puzzle = null;

            [].forEach.call(puzzlesJson, function(g) 
            {      
                if (g["d"] === selectedDate) 
                {
                    puzzle = g;
                }
            }); 

            var topWords = lib.getTopWords(puzzle);
            
            lib.handleShare(selectedGameCompleted["gameNumber"], 
                selectedGameCompleted["percentage"] + "%", 
                selectedGameCompleted["score"], 
                puzzle["p"], 
                userGame == null ? "?" : userGame["hints"].length, 
                userGame == null ? "?" : getTopFoundWordNumbers(topWords, userGame["foundWords"]));
        });        
    }

    function restartGame()
    {
        // wipe all stats & user game data for selectedPuzzleNumber
        userGames = userGames.filter(function(g) 
        {
            return g["gameNumber"] !== selectedPuzzleNumber;
        });

        storage.saveGameData(userGames);

        // remove from completed games
        completedGames = completedGames.filter(function(g) 
        {
            return g["gameNumber"] !== selectedPuzzleNumber;
        });

        var statsJson = storage.getStats();
        
        if (statsJson !== null)
        {
            var statsData = JSON.parse(statsJson); 

            storage.saveStats(completedGames,
                statsData["maxStreak"],
                statsData["currentStreak"],
                statsData["averagePercentage"],
                completedGames.length
            );            
        }   

        
        playGame(selectedPuzzleNumber);
        
        refreshStats();
    }

    function getTopFoundWordNumbers(topWords, foundWords)
    {
        var topWordsIndexes = [];
        var topFoundWordNumbers = "";

        for (var i = 0; i < foundWords.length; i++) 
        {   
            if (topWords.includes(foundWords[i]["word"])) {
                topWordsIndexes.push(topWords.indexOf(foundWords[i]["word"]));
            }
        }
        topWordsIndexes.sort((a, b) => a - b);

        [].forEach.call(topWordsIndexes, function(i) 
        {
            topFoundWordNumbers += (i + 1) + ",";
        });

        if (topFoundWordNumbers == "") {
            topFoundWordNumbers = "-"
        }
        else {
            topFoundWordNumbers = topFoundWordNumbers.substring(0, topFoundWordNumbers.length - 1);
        }
        
        return topFoundWordNumbers;
    }

    function refreshStats()
    {
        const event = new CustomEvent('refreshStatsEvent', {});

        document.dispatchEvent(event);
    }

    function playGame(gameNumber)
    {
        const event = new CustomEvent('gameChangeEvent', {
            detail: {
                gameNumber: gameNumber,
            },
        });

        document.dispatchEvent(event);
    }

    function initCalendar(completedGames) 
    {
        bindEvents();
        updateCalendar();
    } 

    return {
        initCalendar: initCalendar,
        updateCompletedGames: updateCompletedGames,
        updateUserGames: updateUserGames,
        refreshCalendar: refreshCalendar,
        updateCalendar: updateCalendar
    };
}();

export { archive }